import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";
import classNames from "classnames";

class TranscriptionTest extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
    this.getTranscriptionTest();
  }

  static getDerivedStateFromProps(props, state) {

    return null;
  }

  componentDidMount = () => {
  }

  componentDidUpdate(_, prevState) {
    
  }

  componentWillUnmount() {
  }

  async submitTranscription() {
    const {
      transcriptionTest,
      updateTranscriptionTest,
    } = this.props;
    const transcript = document.getElementById('transcript').value;
    const response = await sendAPIRequest(`/onboarding/submit_transcription_test`, "POST", { test: transcriptionTest, transcript: transcript });
    if (response.data.status == 'failure') {
      updateTranscriptionTest(response.data.transcriptionTest)
      this.setState({ status: 'failure' })
    } else if (response.data.status == 'success') {
      this.setState({ status: 'success', nextOnboardingStep: response.data.onboardingStep })
    } else {
      throw new Error("invalid status for transcript submission: " + response.data.status)
    }
  }

  async getTranscriptionTest() {
    const {
      updateTranscriptionTest,
    } = this.props;
    const response = await sendAPIRequest(`/onboarding/get_transcription_test`, "GET");
    if (response.data.status == 'success') {
      updateTranscriptionTest(response.data.transcriptionTest)
    } else {
      throw new Error("invalid status for transcript request: " + response.data.status)
    }
  }

  retakeTest() {
    this.setState({ status: null })
  }

  continueOnboarding() {
    this.props.updateOnboardingStep(this.state.nextOnboardingStep)
  }

  render() {
    const {
      currentContractor,
      transcriptionTest,
    } = this.props;

    const {
      status
    } = this.state;

    if (status == 'failure') {
      return (
        <div className={"onboarding-transcription-container onboarding-transcription-aligned"}>
          <div className="onboarding-transcription-failure-icon">   
            <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="35" cy="35" r="35" fill="#F23D60"/>
            </svg>
            <svg className="svg-middle" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 3L3 24" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <svg className="svg-middle svg-rotate" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M24 3L3 24" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <div className="onboarding-transcription-failure-message">
            Unfortunately, you did not pass the test.
            <br />
            Feel free to try again!
          </div>
          <Button className="onboarding-transcription-retake" onClick={() => this.retakeTest()} text="Re-take Transcription Test" />
        </div>
      );
    } else if (status == 'success') {
      return (
        <div className={"onboarding-transcription-container onboarding-transcription-aligned"}>
          <img className="onboarding-transcription-success-head" src={require(`../../assets/bg-success.jpg`)} />
          <div className="onboarding-transcription-success-title">
            You got the job, {currentContractor.first_name}!
          </div>
          <div className="onboarding-transcription-success-subtitle">
            Welcome to the QA World Transcription Team!
          </div>
          <div className="onboarding-biglabel onboarding-transcription-success-text">
            Congratulations on passing our Transcription Assessment Test. We believe you will be an excellent addition to our team and we are very much looking forward to having you on board.
            <br /> <br />
            As a transcriber, you will be paid at a rate of approximately $0.20 per audio minute transcription (rate varies based on the quality of the transcript and difficulty of the call) and for which payout will be on a weekly basis on Wednesday Evening PDT.
            <br /> <br />
            Transcription is done via QA World’s very own transcription platform. Your username will be your email, <span className="onboarding-biglabel-bold">{currentContractor.email}</span>.
            <br /> <br />
            Our Slack workspace is our main and real-time support community and in a couple minutes we will guide you through setting it up. On Slack, you can always reach out to us for any questions, clarifications or anything else we can be of help to make transcription an enjoyable and rewarding task for you.
          </div>
          <Button className="onboarding-transcription-retake" onClick={() => this.continueOnboarding()} text="Set Up Account" />
        </div>
      );
    }

    return (
      <div className="onboarding-transcription-container">
        <div className="onboarding-title">
          English Transcription Test
        </div>
        <div className="onboarding-transcription-description">
          Below is a short audio clip. Please listen to and transcribe (in English) the entire clip as best as possible. Do not summarize - write each word you hear.
          <br /><br />
          Where appropriate, please use correct punctuation (commas, question marks, etc.) This is a quick test of your basic understanding of english audio comprehension, spelling and grammar. If you pass, you will be approved for paid transcription on the platform.
        </div>
        <div className="onboarding-transcription-video">
          <iframe width="320" height="240" src={transcriptionTest} frameBorder="0" gesture="media" allow="encrypted-media" allowFullScreen />
        </div>
        <div className="onboarding-label">Transcript</div>
        <textarea id="transcript" className="onboarding-transcription-transcript" placeholder="Your transcription" />
        <Button className="onboarding-transcription-submission" onClick={() => this.submitTranscription()} text="Submit Transcription" />
      </div>
    );
  }

}

export default TranscriptionTest;
